import React, { Component, createRef } from 'react';
import Moment from 'react-moment';
import ReactPlayer from 'react-player'

export default class MessageDetailItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedImage: null,
            isVisible: false, // Để track xem component có trong viewport không
            shouldLoadMedia: false // Lazy load images/videos
        };
        this.itemRef = createRef();
        this.observer = null;
        this.handleImageClick = this.handleImageClick.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    componentDidMount() {
        // Sử dụng Intersection Observer để lazy load images/videos
        if ('IntersectionObserver' in window && this.itemRef.current) {
            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.setState({ 
                                isVisible: true,
                                shouldLoadMedia: true 
                            });
                            // Unobserve sau khi đã load
                            if (this.observer && this.itemRef.current) {
                                this.observer.unobserve(this.itemRef.current);
                            }
                        }
                    });
                },
                {
                    rootMargin: '100px' // Load trước 100px khi scroll đến
                }
            );
            this.observer.observe(this.itemRef.current);
        } else {
            // Fallback: load ngay nếu không support IntersectionObserver
            this.setState({ isVisible: true, shouldLoadMedia: true });
        }
    }

    componentWillUnmount() {
        // Cleanup Intersection Observer
        if (this.observer && this.itemRef.current) {
            this.observer.unobserve(this.itemRef.current);
            this.observer = null;
        }
        // Cleanup modal
        if (this.state.selectedImage) {
            this.setState({ selectedImage: null });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // Chỉ re-render nếu props hoặc state thay đổi thực sự
        const propsChanged = 
            nextProps.messageDetail?.key !== this.props.messageDetail?.key ||
            nextProps.messageDetail?.originalMessage !== this.props.messageDetail?.originalMessage ||
            nextProps.messageDetail?.message !== this.props.messageDetail?.message ||
            nextProps.user?.facebookId !== this.props.user?.facebookId ||
            nextProps.targetUser?.fromUserId !== this.props.targetUser?.fromUserId;
        
        const stateChanged = 
            nextState.selectedImage !== this.state.selectedImage ||
            nextState.shouldLoadMedia !== this.state.shouldLoadMedia;
        
        return propsChanged || stateChanged;
    }

    handleImageClick(imageUrl) {
        this.setState({ selectedImage: imageUrl });
    }

    handleCloseModal() {
        this.setState({ selectedImage: null });
    }

    render() {
        const { messageDetail, user, targetUser } = this.props;
        const { shouldLoadMedia } = this.state;
        
        // Convert string to array if it's a JSON-formatted array
        let messageArray = messageDetail.originalMessage;
        if (typeof messageArray === 'string' && (messageDetail.type === "image" || messageDetail.type === "video")) {
            try {
                messageArray = JSON.parse(messageArray);
            } catch (error) {
                console.error("Error parsing messageDetail.message:", error);
            }
        }

        const messageKey = messageDetail.key || messageDetail.firebaseId || 
                      `${messageDetail.dateTime}-${messageDetail.userId}`;

        return (
            <div ref={this.itemRef}>
                {messageDetail.userId === targetUser.fromUserId ? (
                    <div className="media w-50 mb-3">
                        <img 
                            src={targetUser.userProfile} 
                            alt="user" 
                            width={50} 
                            className="rounded-circle"
                            loading="lazy"
                        />
                        <div className="media-body ml-3">
                            <div className="bg-light rounded py-2 px-3 mb-2 my-message">
                                {messageDetail.type === "image" && Array.isArray(messageArray) ? (
                                    // Lazy load images
                                    shouldLoadMedia ? (
                                        messageArray.map((imageUrl, index) => (
                                            <img
                                                key={`${messageKey}-img-${index}`}
                                                style={{ maxWidth: '200px', marginRight: '5px', cursor: 'pointer' }}
                                                src={imageUrl}
                                                alt={`img-${index}`}
                                                loading="lazy"
                                                onClick={() => this.handleImageClick(imageUrl)}
                                            />
                                        ))
                                    ) : (
                                        <div style={{ 
                                            width: '200px', 
                                            height: '150px', 
                                            background: '#f0f0f0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: '8px'
                                        }}>
                                            <i className="fa-solid fa-image" style={{ color: '#ccc' }}></i>
                                        </div>
                                    )
                                ) : messageDetail.type === "video" && Array.isArray(messageArray) ? (
                                    // Chỉ render ReactPlayer khi trong viewport để tiết kiệm RAM
                                    shouldLoadMedia ? (
                                        messageArray.map((videoUrl, index) => (
                                            <ReactPlayer 
                                                key={`${messageKey}-video-${index}`}
                                                url={videoUrl} 
                                                controls={true} 
                                                width='220px' 
                                                height='125px'
                                                playing={false} // Không auto-play để tiết kiệm RAM
                                            />
                                        ))
                                    ) : (
                                        <div style={{ 
                                            width: '220px', 
                                            height: '125px', 
                                            background: '#f0f0f0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: '8px',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => this.setState({ shouldLoadMedia: true })}
                                        >
                                            <i className="fa-solid fa-play" style={{ color: '#ccc', fontSize: '24px' }}></i>
                                        </div>
                                    )
                                ) : (
                                    // Render text message if not an image or video
                                    <p className="text-small mb-0 text-muted">
                                        {messageDetail.originalMessage != null
                                            ? messageDetail.originalMessage
                                            : messageDetail.message}
                                    </p>
                                )}
                            </div>
                            <p className="small text-muted">
                                Gửi vào ngày <Moment withTitle format="MM/DD">{messageDetail.dateTime}</Moment>,
                                lúc <Moment withTitle format="hh:mm">{messageDetail.dateTime}</Moment>
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="media w-50 ml-auto mb-3">
                        <div className="media-body d-flex flex-column align-items-end">
                            <div className="bg-primary rounded py-2 px-3 mb-2 target-message">
                                {messageDetail.type === "image" && Array.isArray(messageArray) ? (
                                    shouldLoadMedia ? (
                                        messageArray.map((imageUrl, index) => (
                                            <img
                                                key={`${messageKey}-img-${index}`}
                                                style={{ maxWidth: '200px', marginRight: '5px', cursor: 'pointer' }}
                                                src={imageUrl}
                                                alt={`img-${index}`}
                                                loading="lazy"
                                                onClick={() => this.handleImageClick(imageUrl)}
                                            />
                                        ))
                                    ) : (
                                        <div style={{ 
                                            width: '200px', 
                                            height: '150px', 
                                            background: 'rgba(255,255,255,0.2)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: '8px'
                                        }}>
                                            <i className="fa-solid fa-image" style={{ color: 'rgba(255,255,255,0.5)' }}></i>
                                        </div>
                                    )
                                ) : messageDetail.type === "video" && Array.isArray(messageArray) ? (
                                    shouldLoadMedia ? (
                                        messageArray.map((videoUrl, index) => (
                                            <ReactPlayer 
                                                key={`${messageKey}-video-${index}`}
                                                url={videoUrl} 
                                                controls={true} 
                                                width='220px' 
                                                height='125px'
                                                playing={false}
                                            />
                                        ))
                                    ) : (
                                        <div style={{ 
                                            width: '220px', 
                                            height: '125px', 
                                            background: 'rgba(255,255,255,0.2)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: '8px',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => this.setState({ shouldLoadMedia: true })}
                                        >
                                            <i className="fa-solid fa-play" style={{ color: 'rgba(255,255,255,0.5)', fontSize: '24px' }}></i>
                                        </div>
                                    )
                                ) : (
                                    <p className="text-small mb-0 text-white">
                                        {messageDetail.originalMessage != null
                                            ? messageDetail.originalMessage
                                            : messageDetail.message}
                                    </p>
                                )}
                            </div>
                            <p className="small text-muted">
                                Gửi vào ngày <Moment withTitle format="MM/DD">
                                    {messageDetail.dateTime}
                                </Moment>,
                                lúc <Moment withTitle format="hh:mm">
                                    {messageDetail.dateTime}
                                </Moment>
                            </p>
                        </div>
                    </div>
                )}
                {this.state.selectedImage && (
                    <div className="image-modal-overlay" onClick={this.handleCloseModal}>
                        <div className="image-modal-container" onClick={(e) => e.stopPropagation()}>
                            <button className="image-modal-close" onClick={this.handleCloseModal}>
                                ✕
                            </button>
                            <img 
                                src={this.state.selectedImage} 
                                alt="Full size" 
                                className="image-modal-image"
                                loading="eager"
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
